export const Indent = ({indent}: {indent: number}) => (
    <div style={{width: indent}}></div>
)